import { fromWireDate } from '@forecastify/shared';

/**
 * The calendar labels the pipeline, the forecast and the demand grid share — in the reader's
 * locale, from a wire date read at LOCAL midnight (`fromWireDate`), never through `new Date(wire)`,
 * which parses a bare date as UTC and can name the day before (`hard-won.md` P1-T7-6).
 */

/** `dec. 15.` / `Dec 15` — a close date on a card, a week's Monday in a column head. */
export function shortDay(wire: string, locale: string): string {
  const date = fromWireDate(wire);
  return date === null
    ? wire
    : new Intl.DateTimeFormat(locale, { month: 'short', day: 'numeric' }).format(date);
}

/**
 * `nov.` / `Nov` — a forecast month. ⚠️ January carries its two-digit year (EN `Jan 27`), as the
 * mockup's `jan 27` does: six months from autumn cross a year, and an unlabelled January reads as
 * the one just gone.
 */
export function shortMonth(wire: string, locale: string): string {
  const date = fromWireDate(wire);
  if (date === null) return wire;
  return new Intl.DateTimeFormat(
    locale,
    date.getMonth() === 0 ? { month: 'short', year: '2-digit' } : { month: 'short' },
  ).format(date);
}
